import { NgModule } from '@angular/core';
import { SignaturePadTypeComponent } from './signature-pad-type.component';
import {
  SignaturePadComponent,
  SignaturePadDatuUrlControlDirective,
} from '@lockton-apps/shared/ui/lui';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [SignaturePadTypeComponent],
  imports: [
    CommonModule,
    SignaturePadComponent,
    SignaturePadDatuUrlControlDirective,
    ReactiveFormsModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'signature-pad',
          component: SignaturePadTypeComponent,
          wrappers: ['form-field', 'addons'],
          defaultOptions: {
            props: {
              label: $localize`E-signature`,
              signatureOptions: {
                placeholder: $localize`Please sign here`,
                canvasWidth: 320,
              },
            },
          },
        },
      ],
    }),
  ],
})
export class SignaturePadTypeModule {}
